module.exports = __webpack_public_path__ + "static/img/paintsplatter.8c274d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/paintsplatter.png
// module id = MgSj
// module chunks = 0